<template>
    <div>
        <!--        Timezone select-->
        <div class="row mt-2 lh-base">
            <div class="col-12 col-md-6">
                <div class="d-flex flex-column flex-md-row justify-content-start">
                    <div class="flex-shrink-0 align-self-center d-none d-md-block">Timezone</div>
                    <div class="flex-grow-1 ms-0 ms-md-3">
                        <vue-multiselect placeholder="Choose Timezone"
                                         v-model="selectedTimezone" label="label" track-by="timezone"
                                         :options="timezoneList" :allow-empty="false"
                                         @input="updateUserTimezone"></vue-multiselect>
                    </div>
                </div>
            </div>
        </div>

        <!--        Day select-->
        <div class="row mt-2 mt-md-4 mb-2">
            <div class="col-10 col-md-11 mx-auto">
                <div class="row gx-1">
                    <VueSlickCarousel v-bind="carouselSettings" ref="daySlider">
                        <div class="col-2 d-grid gap-2 mx-auto px-1" v-for="(day, index) in listOfDays"
                             :key="'d-' + day">
                            <input type="radio" class="btn-check" name="day-check" :id="'btn-day-check-'+index"
                                   :value="day" v-model="selectedDate" autocomplete="off"/>
                            <label class="btn btn-outline-primary" :for="'btn-day-check-'+index">
                                {{ day | moment('ddd, MMM DD, YYYY') }}
                            </label>
                        </div>
                    </VueSlickCarousel>
                </div>
            </div>
        </div>

        <!--        Availability Blocks-->
        <div class="row mt-1 mt-md-2 gx-1">
            <div class="col-12">
                <h5>Select Availabilities</h5>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadioMinute"
                           :value="30" v-model="blockTime">
                    <label class="form-check-label" for="inlineRadioMinute">30 minutes</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadioHour"
                           :value="60" v-model="blockTime">
                    <label class="form-check-label" for="inlineRadioHour">60 minutes</label>
                </div>
            </div>
            <div class="col-12">
                <div class="row gx-2">
                    <div class="mb-1 d-grid gap-2 col-4 col-md-2" v-for="(i, index) in timeBlockArray" :key="index">
                        <input type="checkbox" class="btn-check" :id="'btn-block-'+index+'-outlined'" :value="i"
                               :disabled="isAppointment(i) || isDisabledSlots(disabledBlocks,i) || (inOverlappedSlot(i) && !inCheckedBlocks(i))"
                               autocomplete="off"
                               @click="checkOverlapSlot"
                               v-model="checkedBlocks">
                        <label class="btn btn-outline-secondary" :for="'btn-block-'+index+'-outlined'">
                            {{ i | moment('timezone',currentTimezone,'HH:mm') }}
                        </label>
                    </div>
                </div>
            </div>
        </div>

        <!--        Custim block select-->
        <div class="row mt-1 mt-md-2">
            <div class="col-12">
                <div class="row">
                    <div class="col">
                        <select class="form-select" ref="fromCustomSelect" v-model="selectedFromTime">
                            <option v-for="fromTime in fromCustomTimeList" :value="fromTime">
                                {{ fromTime | moment('timezone',currentTimezone,'HH:mm') }}
                            </option>
                        </select>
                    </div>
                    <div class="col">
                        <select class="form-select" ref="toCustomSelect" v-model="selectedToTime">
                            <option v-for="toTime in toCustomTimeList" :value="toTime">
                                {{ toTime | moment('timezone',currentTimezone,'HH:mm') }}
                            </option>
                        </select>
                    </div>
                    <div class="col">
                        <button type="button" class="btn btn-success mb-3" @click="addCustomSlot">
                            <i class="fa fa-fw fa-plus me-1"></i> Add Custom Time
                        </button>
                    </div>
                </div>
            </div>

            <div class="col-12" v-if="customEventList.length">
                <custom-time-items :timezone="currentTimezone"
                                   :index="index" :item="customTimeItem"
                                   v-for="(customTimeItem, index) in customEventList"
                                   @remove="removeCustomSlot(index)"
                                   :key="index.toString()"></custom-time-items>
            </div>
        </div>

        <div class="d-grid gap-2 col-2 mx-auto mt-5 mb-2">
            <button class="btn btn-primary" @click="updateSlotState">
                <span v-if="updatingAvailabilities" class="spinner-border spinner-border-sm" role="status"
                      aria-hidden="true"></span> Save Availabilities
            </button>
            <!--            Staff buttons-->
            <a v-if="availabilityPage && isStaff" class="btn btn-info float-end float-md-none" :href="availabilityPage">Send
                Calendar Invite</a>

            <!--            Expert buttons-->
            <availability-modal v-if="isExpert" :show="showAvailabilityModal"
                                :user-zone="currentTimezone"></availability-modal>
        </div>

        <div v-if="isExpert">
            <!--        begin of confirm modal-->
            <div class="modal" tabindex="-1" ref="confirmModal">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Please confirm your timezone</h5>
                        </div>
                        <div class="modal-body">
                            <vue-multiselect placeholder="Choose Timezone"
                                             v-model="confirmTimezone" label="label" track-by="timezone"
                                             :options="timezoneList" :allow-empty="false"
                            ></vue-multiselect>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary"
                                    @click="confirmTimezoneModal(confirmTimezone)">
                                Confirm
                            </button>
                            <button class="btn btn-outline-dark" @click="confirmTimezone = getSelectTimezone(browserTimezone)">
                                <i class="fa fa-location-arrow"></i></button>
                        </div>
                    </div>
                </div>
            </div>
            <!--        end of confirm modal-->
        </div>
    </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import VueMultiselect from 'vue-multiselect'

import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import moment from 'moment-timezone'
import { mapGetters } from 'vuex'
import { Modal } from 'bootstrap'

export default {
    name: 'AlphaCalendar',
    components: { VueSlickCarousel, VueMultiselect },
    props: {
        'assignmentId': {
            type: Number,
            required: true,
        },
        'userZone': {
            type: String,
        },
        'availabilityPage': {
            type: String,
            default: null,
        },
        'projectTitle': {
            type: String,
        },
        'projectId': {
            type: Number,
        },
        'expertName': {
            type: String,
        },
        'userId': {
            type: Number,
        },
        'userType': {
            type: String,
            required: true,
        },
    },
    data () {
        return {
            oldTimezone: null,
            selectedDate: null,
            carouselSettings: {
                'dots': false,
                'arrows': true,
                'focusOnSelect': false,
                'infinite': false,
                'speed': 500,
                'slidesToShow': 6,
                'slidesToScroll': 6,
                'initialSlide': 0,
                'responsive': [
                    {
                        'breakpoint': 1024,
                        'settings': {
                            'slidesToShow': 3,
                            'slidesToScroll': 3,
                        },
                    },
                    {
                        'breakpoint': 600,
                        'settings': {
                            'slidesToShow': 2,
                            'slidesToScroll': 2,
                            'initialSlide': 2,
                        },
                    },
                    {
                        'breakpoint': 480,
                        'settings': {
                            'slidesToShow': 1,
                            'slidesToScroll': 1,
                        },
                    },
                ],
                // 'touchThreshold': 5,
                // "variableWidth": true
            },
            updatingAvailabilities: false,
            selectedFromTime: null,
            selectedToTime: null,
            removedCustomSlots: [],
            disabledBlocks: [],
            showTimezoneDialog: false,
            showAvailabilityModal: false,
            updatingTimezone: false,
            confirmTimezone: { label: moment.tz.guess(), timezone: moment.tz.guess() },
        }
    },
    watch: {
        showTimezoneDialog: function (show) {
            if (show) {
                this.confirmModal.show()
            } else {
                this.confirmModal.hide()
            }
        },
        currentTimezone: function (timezone, oldTimezone) {
            this.oldTimezone = oldTimezone
            this.selectedDate = this.$moment.tz(timezone).format(this.$moment.HTML5_FMT.DATE)
            this.fetchAvailabilities()
        },
        customTimeList: function (newList) {
            const uncheckedBlocks = _.difference(this.timeBlockArray, this.checkedBlocks)
            this.disabledBlocks = uncheckedBlocks.filter(time => { //block in custom list will be disabled
                const startTime = this.$moment(time)

                return newList.some(customBlock => {
                    const blockTime = this.$moment(customBlock.start)
                    return startTime.isSame(blockTime, 'hour') && startTime.isSame(blockTime, 'minute')
                })
            })
        },
    },
    computed: {
        browserTimezone () {
            return moment.tz.guess()
        },
        confirmModal () {
            const target = this.$refs.confirmModal
            return new Modal(target, { backdrop: 'static', keyboard: false })
        },
        selectedTimezone: {
            get () {
                return this.getSelectTimezone(this.$store.state.events.userTimezone)
            },
            set (value) {
                this.$store.commit('events/setUserTimezone', value.timezone)
            },
        },
        checkedBlocks: {
            get () {
                return this.$store.state.events.timeSlots
            },
            set (slotArray) {
                this.$store.commit('events/updateSlots', slotArray)
            },
        },
        timeBlockArray () {
            return this.generateTimeList(this.blockTime, this.startTime, this.endTime)
        },
        blockTime: {
            get () {
                return this.$store.state.events.blockTime
            },
            set (value) {
                this.$store.commit('events/updateBlockTime', value)
            },
        },
        customTimeList: {
            get () {
                return this.$store.getters['events/customTimeSlots']
            },
            set (slots) {
                this.$store.commit('events/updateCustomSlots', slots)
            },
        },
        customEventList () {
            const allSlots = this.customTimeList
            const selectedDate = this.$moment.tz(this.selectedDate, this.currentTimezone)

            return allSlots.filter(time => {
                const start = this.$moment.tz(time.start, this.currentTimezone),
                    end = this.generateEndTime(start, this.blockTime)
                return start.isSame(selectedDate, 'day') && end.isSame(selectedDate, 'day')
            })
        },
        selectDateMoment () {
            if (this.selectedDate !== null) {
                return this.$moment.tz(this.selectedDate, this.currentTimezone)
            }
            return false
        },
        startTime () {
            if (!this.selectDateMoment || !this.selectDateMoment.isValid()) {
                return this.$moment.tz({ 'h': 0, 'm': 0 }, this.currentTimezone)
            }

            const selectDate = this.selectDateMoment.tz(this.currentTimezone)
            let isToday = false

            const localHour = this.$moment.tz(this.currentTimezone).format('H')
            let selectDateObj = {}
            let startTime = null

            if (selectDate.isSame(this.$moment.tz(this.currentTimezone), 'day')) {
                isToday = true
                selectDateObj = this.setDayTime(selectDate, localHour)
            } else {
                selectDateObj = this.setDayTime(selectDate, 0)
            }

            startTime = this.$moment.tz(selectDateObj, this.currentTimezone)
            if (isToday && 23 !== parseInt(localHour)) {
                startTime.add(1, 'h')
            }

            return startTime
        },
        endTime () {
            if (!this.selectDateMoment || !this.selectDateMoment.isValid()) {
                return this.$moment.tz({ 'h': 23, 'm': 0 }, this.currentTimezone)
            }

            const selectDateObj = this.setDayTime(this.selectDateMoment, 23)
            return this.$moment.tz(selectDateObj, this.currentTimezone)
        },
        listOfDays () {
            const dayArray = []
            const today = this.$moment.tz(this.currentTimezone)
            const endDay = today.clone().add(2, 'w')

            while (today.isSameOrBefore(endDay, 'd')) {
                dayArray.push(today.format(this.$moment.HTML5_FMT.DATE))
                today.add(1, 'd')
            }

            return dayArray
        },
        allEvents () {
            const events = this.availableEvents
            return events.filter((event) => {
                const startTime = this.$moment.tz(event.start, this.currentTimezone)
                return startTime.isValid() && startTime.isAfter(this.$moment.tz(this.currentTimezone), 'hour')
            })
        },
        allAvailableEvents () {
            const allCheckedEvents = this.checkedBlocks.map(block => {
                const start = this.$moment.utc(block), end = this.generateEndTime(start, this.blockTime)
                return { 'start': start.valueOf(), 'end': end.valueOf(), 'type': 1, 'id': null }
            })
            return _.concat(this.customTimeList, allCheckedEvents)
        },
        allAvailableSlots () {
            return this.allEvents.filter(event => event.eventType === 'availability')
        },
        allCustomSlots () {
            return this.allEvents.filter(event => event.eventType === 'available_custom')
        },
        eventBlocks () {
            return this.allAvailableSlots.map(event => event.start)
        },
        allSelectedBlocks () {
            return _.union(this.eventBlocks, this.checkedBlocks)
        },
        allBlocks () {
            return this.allSelectedBlocks.map(block => {
                const start = this.$moment.utc(block), end = this.generateEndTime(start, this.blockTime)
                return { 'start': start.valueOf(), 'end': end.valueOf(), 'type': 1, 'id': null }
            })
        },
        fromCustomTimeList () {
            return this.generateTimeList(15, this.startTime, this.endTime)
        },
        toCustomTimeList () {
            return this.generateTimeList(15, this.startTime, this.endTime)
        },
        overlappedSlots () {
            const blockArray = this.timeBlockArray
            return blockArray.filter((slot) => {
                return this.isOverlappedSlot(slot, this.blockTime)
            })
        },
        isExpert () {
            return this.userType === 'expert'
        },
        isStaff () {
            return this.userType === 'staff'
        },
        isClient () {
            return this.userType === 'client'
        },
        ...mapGetters({
            timezoneList: 'events/timezoneNamedList',
            currentTimezone: 'events/userTimezone',
            appointments: 'events/appointments',
            availableEvents: 'events/eventBlocks',
        }),
    },
    methods: {
        isAppointment (time) {
            return _.includes(this.appointments, time)
        },
        isDisabledSlots (disabledList, time) {
            return _.includes(disabledList, time)
        },
        inOverlappedSlot (time) {
            return _.includes(this.overlappedSlots, time)
        },
        inCheckedBlocks (time) {
            return _.includes(this.checkedBlocks, time)
        },
        isOverLapped (eventTime, list) {
            const overlappedList = list.filter(event => {
                const start = this.$moment.utc(event.start), end = this.$moment.utc(event.end)
                const startTime = this.$moment.utc(eventTime.start), endTime = this.$moment.utc(eventTime.end)

                return startTime.isBefore(end) && endTime.isAfter(start)
            })

            return overlappedList.length
        },
        checkOverlapSlot (event) {
            if (event.target.checked) {
                const isOverlap = this.isOverlappedSlot(parseInt(event.target.value), this.blockTime)
                if (isOverlap) {
                    alert('Time overlapped')
                    event.preventDefault()
                }
            }
        },
        isOverlappedSlot (time, period) {
            const startTime = this.$moment.utc(time),
                endTime = this.generateEndTime(startTime, period)

            const timeItem = { 'start': startTime.valueOf(), 'end': endTime.valueOf() }

            if (this.allAvailableEvents.length === 0) {
                return false
            }

            return this.isOverLapped(timeItem, this.allAvailableEvents)
        },
        confirmTimezoneModal (timezone) {
            this.$store.commit('events/setUserTimezone', timezone.timezone)

            this.updateUserTimezone(timezone)
            alert('Timezone confirmed.')
            this.showTimezoneDialog = false
        },
        updateUserTimezone (value, id) {
            if (this.userId !== undefined) {
                this.$store.dispatch('events/updateUserTimezone', {
                    userId: this.userId.toString(),
                    timezone: value.timezone,
                    oldTimezone: this.userZone,
                })
                this.fetchAvailabilities()
            }
        },
        fetchAvailabilities () {
            return this.$store.dispatch('events/getEvents', {
                id: this.assignmentId,
                zone: this.currentTimezone,
                expertName: this.expertName,
                projectTitle: this.projectTitle,
            })
        },
        updateBlocks (timeBlocks, eventBlocks, blockTime) {
            return new Promise((resolve, reject) => {
                let assignmentId
                if (this.assignmentId) {
                    assignmentId = this.assignmentId
                } else {
                    let url = window.location.pathname
                    this.url = url.substring(1, 6)
                    assignmentId = url.substring(url.lastIndexOf('/') + 1)
                }

                const customEvents = this.customTimeList

                const allBlocks = _.concat(this.allBlocks, customEvents) //get all block and custom blocks

                allBlocks.forEach((selectedBlock, index, array) => {
                    // const blockTimeUTC = this.$moment.utc(selectedBlock)
                    const blockStartTime = selectedBlock.start, endTime = selectedBlock.end

                    const inChecked = _.includes(timeBlocks, blockStartTime)
                    const inEvent = _.includes(eventBlocks, blockStartTime)

                    if (!inChecked && inEvent && selectedBlock.type === 1) { //delete old blocks
                        console.log('delete old blocks')
                        console.dir(selectedBlock)
                        if (selectedBlock.id !== null) {
                            this.$store.dispatch('events/deleteEvent', { eventId: selectedBlock.id, meetingId: null })
                        } else {
                            this.$store.dispatch('events/deleteEventByStart',
                                {
                                    startTime: blockStartTime,
                                    endTime: endTime,
                                    type: selectedBlock.type,
                                    assignmentId: assignmentId,
                                    zone: this.currentTimezone,
                                    expertName: this.expertName,
                                    projectTitle: this.projectTitle,
                                })
                        }
                    } else if ((inChecked && !inEvent) ||
                        (customEvents.length && selectedBlock.type === 3 && selectedBlock.id === null)) { //save new blocks
                        const availability = {
                            start: blockStartTime,
                            end: endTime,
                            type: selectedBlock.type,
                            assignmentId: assignmentId,
                        }

                        this.$store.dispatch('events/newCreateEvent',
                            { availability: availability, zone: this.currentTimezone })
                    }
                    if (index === array.length - 1) resolve()
                })
            })
        },
        updateSlotState () {
            this.updatingAvailabilities = true
            this.updateBlocks(this.checkedBlocks, this.eventBlocks, this.blockTime).then(() => {
                setTimeout(() => {
                    this.updatingAvailabilities = false
                    this.fetchAvailabilities()
                    alert('Availabilities saved.')
                }, 1000)
            })
        },
        setDayTime (momentDay, hour) {
            return {
                'y': momentDay.format('YYYY'),
                'M': parseInt(momentDay.format('M')) - 1,
                'd': momentDay.format('D'),
                'h': hour,
                'm': 0,
            }
        },
        detectZone () {
            const browserTimezone = moment.tz.guess()
            let clientTimezone = browserTimezone

            if (this.userZone) {
                clientTimezone = this.userZone
            }

            this.$store.commit('events/setUserTimezone', clientTimezone)

            if (this.isExpert && (this.userZone === '' || this.userZone !== browserTimezone)) {
                this.showTimezoneDialog = true
            }
        },
        getSelectTimezone (timezone) {
            return { label: timezone, timezone: timezone }
        },
        getTimeBlocks (checkedBlocks, currentTimezone, blockTime) {
            return checkedBlocks.map(function (startTimeUnix) {
                const startTime = this.$moment.tz(startTimeUnix, currentTimezone)
                let endTime = startTime.clone().add(30, 'm')

                if (blockTime === 60) {
                    endTime = startTime.clone().add(1, 'h')
                }

                return { 'start': startTime.valueOf(), 'end': endTime.valueOf() }
            }, this)
        },
        generateTimeList (period, start, end) {
            let blocks = []

            const startBlockTime = start.utc().clone()
            const endBlockTime = end.utc().clone()

            while (startBlockTime.isSameOrBefore(endBlockTime, 'hour')) {
                const timeBlock = startBlockTime.valueOf()

                blocks.push(timeBlock)

                if (period === 30 || period === 15) {
                    startBlockTime.add(period, 'm')
                } else if (period === 60) {
                    startBlockTime.add(1, 'h')
                }
            }

            return blocks
        },
        addCustomSlot () {
            if (this.selectedFromTime === null || this.selectedToTime === null) {
                alert('Please select custom time range')
                return false
            }

            const fromTime = this.$moment(this.selectedFromTime), toTime = this.$moment(this.selectedToTime)
            const customItem = { id: null, 'start': fromTime.valueOf(), 'end': toTime.valueOf(), 'type': 3 }

            if (fromTime.isSameOrAfter(toTime)) {
                alert('Start time must be after end time')
                return false
            }

            const duplicateItems = this.customTimeList.filter((timeItem) => {
                const itemStart = this.$moment(timeItem.start), itemEnd = this.$moment(timeItem.end)
                return itemStart.isSame(fromTime) && itemEnd.isSame(toTime)
            })

            if (duplicateItems.length) {
                alert('Duplicated custom time')
                return false
            }

            const overlapped = this.isOverLapped(customItem, this.allAvailableEvents)
            if (overlapped) {
                alert('Time overlapped')
                return false
            }

            this.$store.commit('events/addCustomSlot', customItem)
        },
        removeCustomSlot (index) {
            this.removedCustomSlots.push(this.customTimeList[index])
            const slotRemove = this.customTimeList[index]

            if (slotRemove.id !== null) {
                this.$store.dispatch('events/deleteEvent', { eventId: slotRemove.id, meetingId: null })
            }

            this.$store.commit('events/removeCustomSlot', index)
        },
        generateEndTime (startTimeUTC, period) {
            let endTime = startTimeUTC.clone().add(30, 'm')
            if (period === 60) {
                endTime = startTimeUTC.clone().add(1, 'h')
            }

            return endTime
        },
    },
    mounted () {
        this.$nextTick(function () {
            this.$store.dispatch('events/getTimeZones')
            this.detectZone()

            this.selectedDate = this.$moment.tz(this.currentTimezone).format(this.$moment.HTML5_FMT.DATE)
        })
    },
}
</script>

<style scoped>
>>> .slick-prev:before {
    color: black;
}

>>> .slick-next:before {
    color: black;
}
</style>
